/* unplugin-vue-components disabled */import { render } from "./Separator.vue?vue&type=template&id=4651b87a&ts=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"

import "./Separator.vue?vue&type=style&index=0&id=4651b87a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__